import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { summariseAssetTasks } from "routes/asset-register/plugins/regime-display/controller/summarise-asset-tasks"
import { Divider, Skeleton, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ListItemBox } from "lib/@components/ListItemBox"
import { formatTime } from "lib/format-time"
import { keyBy } from "lib/keyBy"
import { dummyResult } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/skills/dummy-result"
import { SkillSummary } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/skills/skill-summary"

export function SkillsSummaries() {
    const { regimeId, group, filters, search } = useBoundContext()
    const summary =
        summariseAssetTasks.useResults({
            regimeId,
            group,
            filters,
            search,
            summarise: ["skill"],
        }) ?? dummyResult
    const results = keyBy(summary, (c) => c.value[0])

    const totalMinutes = summary.sum("minutes")
    const totalTasks = summary.sum("count")

    return summary === dummyResult ? (
        <Skeleton animation="wave" sx={{ m: 2 }} variant="rounded" height={120} />
    ) : (
        <>
            <Stack direction="row" justifyContent="flex-start" flexWrap="wrap" sx={{ p: 2 }}>
                <Repeat
                    list={Object.keys(results).sort()}
                    item={<SkillSummary results={results} totalMinutes={totalMinutes} />}
                />
            </Stack>
            <Divider />
            <ListItemBox px={2} py={0.5}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold" }}>
                    {formatTime(totalMinutes)} per annum for {totalTasks.toLocaleString()}{" "}
                    {"task".pluralize(totalTasks)}
                </Typography>
            </ListItemBox>
        </>
    )
}
